import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_MAP_ID } from './api';

export const MAP_CONFIG = {
  apiKey: GOOGLE_MAPS_API_KEY || '',
  mapId: GOOGLE_MAPS_MAP_ID || undefined,
  defaultZoom: 13,
  mapOptions: {
    disableDefaultUI: false,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: true,
    ...(GOOGLE_MAPS_MAP_ID ? { mapId: GOOGLE_MAPS_MAP_ID } : {}),
  },
};

declare global {
  interface Window {
    google: any;
  }
}

